import {    Injectable          } from '@angular/core';
import {    NgxSpinnerService   } from "ngx-spinner";
import {    Spinner             } from 'ngx-spinner/lib/ngx-spinner.enum';

@Injectable({
  providedIn: 'root'
})
export class LoadingManager {

    name: string = "main_spinner"

    spinner: Spinner = {
        type        : "square-loader"   ,
        size        : "medium"          ,
        bdColor     : "rgba(51,51,51,0.8)",
        color       : "white"           ,
        fullScreen: true
    }

    constructor(
        private _spinner: NgxSpinnerService
    ) { 
          
    }

    start()
    {
        this._spinner.show(this.name, this.spinner)
    }

    stop()
    {
        this._spinner.hide(this.name)
    }

}
